import { lazy } from "react";
import { ElementDetails } from "@/lib/types";
import { GithubActionsProps } from "./types";

export const details = {
  name: "GithubActions",
  description: "Displays a list of your Github actions",
  tags: ["Development"],
  category: "Github",
  grid: { default: [3, 3], large: [4, 4] },
  gridNames: { default: "Medium", large: "Large" },
  setup: lazy(() => import("./Setup").then(m => ({ default: m.Setup }))),
  integrationsUsed: ["github"],
  defaultProps: {},
} as ElementDetails<GithubActionsProps>;
